import React from 'react';
import nebulaTheme from '@nebula/theme';
import { TickIcon, DashIcon, iconSizes } from '@nebula/icons/ui';
import { ValueText } from './index.styles';

interface EntitlementValueProps {
  value: { included: boolean; text?: string } | undefined;
  iconSize?: iconSizes;
  /** Always render a tick/dash, even when the value carries qualifier text. */
  iconOnly?: boolean;
}

const EntitlementValue: React.FC<EntitlementValueProps> = ({ value, iconSize, iconOnly }) => {
  if (!value?.included) {
    return <DashIcon iconColor={nebulaTheme.color.ui.grey[40]} iconSize={iconSize} ariaHidden />;
  }

  if (!iconOnly && value.text) {
    // Hidden because the cell announces this qualifier as part of its own sentence.
    return <ValueText aria-hidden="true">{value.text}</ValueText>;
  }

  return <TickIcon iconColor={nebulaTheme.color.messaging.green[70]} iconSize={iconSize} ariaHidden />;
};

export default EntitlementValue;
